import { WeightLogResponse } from '@/shared/interfaces/api/sundvaegt-interfaces';
import { formatNumber } from '@/shared/helpers/formatNumber';
import { Utils } from '@/shared/Utils';

export const createWeightLogCards = (
    logs: WeightLogResponse[],
    initialWeight: number,
    formattedTotalWeightLossGoal: string,
) => {
    return logs.map((log, i) => {
        const isFirstLog = i === logs.length - 1;
        const previousLog = isFirstLog ? null : logs[i + 1];

        const weight = Number(log.WeightKg);

        const lastWeightLoss = isFirstLog
            ? null
            : Number(previousLog?.WeightKg) - weight;

        let totalWeightLoss = Number(initialWeight) - weight;
        if (totalWeightLoss < 0) totalWeightLoss = 0;

        const weightFormatted = formatNumber(weight);
        const lastWeightLossFormatted = formatNumber(lastWeightLoss);
        const totalWeightLossFormatted = formatNumber(totalWeightLoss);

        const date = new Date(log.Date);
        const formattedDate = Utils.formatLongDate(date);

        return {
            Id: log.Id,
            WeightKg: log.WeightKg,
            Date: log.Date,
            formattedWeight: `${weightFormatted} kg`,
            formattedDate: formattedDate,
            formattedLastLoss: isFirstLog
                ? null
                : `${lastWeightLossFormatted} kg`,
            formattedTotalLoss: `${totalWeightLossFormatted}`,
            formattedTotalWeightLossGoal: formattedTotalWeightLossGoal,
            isFirstLog,
        };
    });
};
